import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NavigationService } from 'services/navigation.service';

interface NavItem {
  text: string;
  logo: React.ReactNode;
  link?: string;
  onClick?: () => void;
}

interface HomeLeftBarProps {
  items: NavItem[];
  needConfirmation: boolean;
}

export const HomeLeftBar: React.FC<HomeLeftBarProps> = ( { items, needConfirmation }: HomeLeftBarProps ) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [ hoveredItem, setHoveredItem ] = useState<string | null>( null );
  const [ isMenuHover, setisMenuHover ] = useState<boolean>( false );

  const handleNavigation = ( link: string ) => {
    NavigationService.navigateTo( link, needConfirmation, navigate );
  };

  return (
    <div className='flex mr-20 fixed top-0 left-0 h-full z-50 shadow-md'>
      <div
        className='rounded-lg flex max-h-screen z-50 relative'
        onMouseEnter={ () => { setisMenuHover( true ); } }
        onMouseLeave={ () => { setisMenuHover( false ); } }
      >
        <div className='flex-col flex bg-white items-center border-r-[1px] text-orange-base h-full w-16 z-30'>
          {items.map( ( item, index ) => { return (
            <button
              key={index}
              className={`pl-4 pr-2 h-full flex-center ${
                hoveredItem === item.text ? 'text-orange-500' : ''
              }`}
              onClick={ () => {
                if ( item.onClick ) {
                  item.onClick();
                }
                if ( item.link ) {
                  handleNavigation( item.link );
                }
              } }
              onMouseEnter={ () => { setHoveredItem( item.text ); } }
              onMouseLeave={ () => { setHoveredItem( null ); } }
            >
              {item.logo}
              <hr
                className={`h-10 w-1 ml-2 rounded-full ease-in-out duration-300 ${
                  hoveredItem === item.text ? 'bg-orange-base' : 'bg-white'
                }`}
              ></hr>
            </button>
          ); } )}
        </div>

        <div
          className={`flex -left-52 flex-col text-xl w-64 pr-2 bg-gray-100 shadow-md shadow-gray-400 absolute z-20 ${
            isMenuHover ? 'left-full' : ''
          } h-full transition-all duration-400 delay-0`}
        >
          {items.map( ( item, index ) => { return (
            <button
              key={index}
              className='h-full flex items-center'
              onClick={ () => {
                if ( item.onClick ) {
                  item.onClick();
                }
                if ( item.link ) {
                  handleNavigation( item.link );
                }
              } }
              onMouseEnter={ () => { setHoveredItem( item.text ); } }
              onMouseLeave={ () => { setHoveredItem( null ); } }
            >
              <div
                className={`relative overflow-hidden ease-in-out duration-200 px-4 w-full text-left py-1.5 rounded-r-xl ${
                  hoveredItem === item.text ? 'text-white' : ''
                }`}
              >
                <span
                  className={`absolute inset-0 transition-transform duration-300 ease-in-out ${
                    hoveredItem === item.text
                      ? 'transform translate-x-0'
                      : 'transform -translate-x-full'
                  } bg-orange-base`}
                ></span>
                <p className='z-10 relative'>{ t( item.text ) }</p>
              </div>
            </button>
          ); } )}
        </div>
      </div>
      <div>
        <div
          className={`absolute h-screen opacity-25 bg-gray-500 ${
            isMenuHover ? 'w-screen' : 'w-0'
          }`}
        ></div>
      </div>
    </div>
  );
};

